
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/polarsteps-alternative",
      function () {
        return require("private-next-pages/polarsteps-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/polarsteps-alternative"])
      });
    }
  